module.exports = __webpack_public_path__ + "static/media/recent-user-3.0bcc6f45.png";